import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { refreshToken } from '@/api/user'

function redirectToLogin() {
  if (process.env.NODE_ENV === 'development') {
    location.href = `${process.env.VUE_APP_BASE_API}/auth?next=${location.pathname}`
  } else {
    location.href = `https://dmpeople.com.br/site/index.html`
  }
}

let isRefreshing = false
let failedRequestsQueue = []
let lastRefreshAt = 0
const REFRESH_GRACE_MS = 30 * 1000 // 30 seconds

async function refreshAndRetry() {
  try {
    isRefreshing = true
    const {data} = await refreshToken()
    const token = data.access_token
    store.dispatch('user/refreshToken', token)
    lastRefreshAt = Date.now()
    failedRequestsQueue.forEach(request => request.onSuccess(token))
  } catch(error) {
    await store.dispatch('user/logout')
    failedRequestsQueue.forEach(request => request.onFailure(error))
  } finally {
    failedRequestsQueue = []
    isRefreshing = false
  }
}

export function attachAuthInterceptors(instance, options = {}) {
  const { acceptLanguage = false, on403 = null, showErrorToast = true } = options

  instance.interceptors.request.use(
    (config) => {
      if (store.getters.token) {
        config.headers['Authorization'] = `Bearer ${getToken()}`
        config.headers['x-tenant-id'] = store.getters.userClient
      }
      if (acceptLanguage && store.getters.locale) {
        config.headers['Accept-Language'] = store.getters.locale
      }
      return config
    },
    (error) => Promise.reject(error)
  )

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {

      if(error.response?.status === 401) {
        const originalConfig = error.config
        const refreshedRecently = lastRefreshAt > 0 && Date.now() - lastRefreshAt < REFRESH_GRACE_MS

        if (refreshedRecently) {
          await store.dispatch('user/logout')
          return Promise.reject(error)
        }

        if(!isRefreshing) {
          refreshAndRetry()
        }

        return new Promise((resolve, reject) => {
          failedRequestsQueue.push({
            onSuccess: (token) => {
              originalConfig.headers['Authorization'] = `Bearer ${token}`;
              resolve(instance(originalConfig))
            },
            onFailure: (error) => {
              reject(error)
            }
          })
        })
      }

      if (
        error.response?.status === 403 &&
        !error.config?.skipForbiddenRedirect &&
        typeof on403 === 'function'
      ) {
        const handled = on403(error)
        if (handled === true) return Promise.reject(error)
      }

      if (showErrorToast) {
        Message({ message: error.message, type: 'error', duration: 5 * 1000 })
      }
      return Promise.reject(error)
    }
  )
}
